import { ActionService } from 'dashboard-services/services';

export default (() => {

    const ON_CHANGE = "ON_CHANGE_SELECTED_USER_SETTINGS"
    const onChange = ActionService.makeActionCreator(ON_CHANGE, "value", "name")

    const CLEAN_ALL = 'CLEAN_ALL_SELECTED_USER_SETTINGS'
    const cleanAll = ActionService.makeActionCreator(CLEAN_ALL)

    return {
      ON_CHANGE,
      onChange,
      cleanAll,
      CLEAN_ALL
    }
})()